export interface ApiErrorBody { error: { code: string; message: string; fields?: Record<string, string> } }
export interface Page<T> { items: T[]; next_cursor: number | null }

export class ApiError extends Error {
  readonly status: number
  readonly code: string
  constructor(status: number, code: string, message: string) { super(message); this.status = status; this.code = code }
}

function csrfToken(): string | undefined {
  const pair = document.cookie.split('; ').find((value) => value.startsWith('hemdan_csrf='))
  return pair?.slice('hemdan_csrf='.length)
}

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const headers = new Headers(options.headers)
  if (options.body) headers.set('Content-Type', 'application/json')
  const method = options.method?.toUpperCase() ?? 'GET'
  if (!['GET', 'HEAD', 'OPTIONS'].includes(method)) {
    const csrf = csrfToken()
    if (csrf) headers.set('X-CSRF-Token', csrf)
  }
  const response = await fetch(`/api/v1${path}`, { ...options, headers, credentials: 'same-origin' })
  if (response.status === 204) return undefined as T
  const data: unknown = await response.json().catch(() => null)
  if (!response.ok) {
    const body = data as Partial<ApiErrorBody> | null
    throw new ApiError(response.status, body?.error?.code ?? 'request_failed', body?.error?.message ?? 'تعذر إتمام الطلب')
  }
  return data as T
}

export function mutationOptions(body: unknown): RequestInit {
  return { method: 'POST', headers: { 'Idempotency-Key': crypto.randomUUID() }, body: JSON.stringify(body) }
}

